import options from './options';
import packages from './packages';
import settings from './settings';
import accessories from './accessories';

const root = {
	options,
	packages,
	settings,
	accessories
};

export default root;
